export const CONTRIBUTOR_CREATION = 'CONTRIBUTOR_CREATION';
export const CONTRIBUTOR_DELETION = 'CONTRIBUTOR_DELETION';
export const CONTRIBUTOR_EDIT = 'CONTRIBUTOR_EDIT';
export const CONFIRMATION = 'CONFIRMATION';
// BUNDLE ASSESSMENTS
export const BUNDLE_CREATION = 'BUNDLE_CREATION';
export const ASSESSMENT_FAQS = 'ASSESSMENT_FAQS';

// BULK SEND INVITES
export const ASSESSMENT_SEND_BULK_INVITES = 'ASSESSMENT_SEND_BULK_INVITES';
// PROFILE CREATION
export const PROFILE_TYPE_CREATION = 'PROFILE_TYPE_CREATION';
export const REPORT_ORDERS_BULK = 'REPORT_ORDERS_BULK';
// client
export const CLIENT_DEACTIVATION = 'CLIENT_DEACTIVATION';

// ACTIONS
export const ASSESSMENT_ACTIONS = 'ASSESSMENT_ACTIONS';

export const ORDER_REPORTS = 'ORDER_REPORTS';
export const PREVIEW_REPORTS_ORDER = 'PREVIEW_REPORTS_ORDER';

// MULTIPLE PROFILE SELECTION
export const MULTIPLE_PROFILES_SELECTION = 'MULTIPLE_PROFILES_SELECTION';

// APP SESSION
export const APP_SESSION = 'APP_SESSION';

// TERMS AND CONDITIONS
export const TERMS_CONDITIONS = 'TERMS_CONDITIONS';

// SELECT_LANGUAGE
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';

// ALERT
export const ALERT = 'ALERT';

// PERMISSION
export const ASIGN_PERMISSION = 'ASIGN_PERMISSION';
export const PERMISSION_DENIED = 'PERMISSION_DENIED';

export const ASSIGN_RECEIVERS = 'ASSIGN_RECEIVERS';

// SCORE
export const SCORE_PROFILE = 'SCORE_PROFILE';

// GENERIC LOADER
export const LOADER = 'LOADER';

// ASSESSMENT REPORTS
export const VIEW_ASSESSMENT_REPORTS = 'VIEW_ASSESSMENT_REPORTS';
export const ORDER_ASSESSMENT_REPORTS = 'ORDER_ASSESSMENT_REPORTS';

// ASSESSMENT INVITES
export const ASSESSMENT_INVITES = 'ASSESSMENT_INVITES';
export const ASSESSMENT_INVITE = 'ASSESSMENT_INVITE';
export const ASSESSMENT_ORDER_CONFIRMATION = 'ASSESSMENT_ORDER_CONFIRMATION';
